// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"712":"da09b709","758":"5e088d2c"}[chunkId] + ".chunk.css";
};